<template>
    <Modal
    :value="open"
    :onClose="close"
    :close="false"
    title="Configuração Pendente"
    >
      <b-row class="form-group">
         <b-col sm="12">
          <p v-if="enableToSendIntermediator">
            Conforme <b>Nota Técnica 2020.006 - v.1.00</b> é necessário enviar os dados do
            intermediador ou agenciador da operação comercial,
            <b>confirma o envio dos dados?</b><br>
            Em caso de dúvida acesse
            <a target="_blank" href="https://suporte.compufour.com.br/artigos/1548">https://suporte.compufour.com.br/artigos/1548</a>
          </p>
          <p v-else>
            Deseja <b>não enviar os dados do intermediador</b> ao emitir o documento?<br>
            Em caso de dúvida acesse
            <a target="_blank" href="https://suporte.compufour.com.br/artigos/1548">https://suporte.compufour.com.br/artigos/1548</a>
          </p>
        </b-col>
      </b-row>
      <div class="confirm-buttons">
        <Button type="error" @click="close()">Não</Button>
        <Button type="success" @click="save()">Sim</Button>
      </div>
    </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';

export default {
  name: 'ModalIntermediatorConfiguration',
  components: {
    Modal,
    Button,
  },
  data() {
    return {
      enableToSendIntermediator: false,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    onSave: {
      type: Function,
      default: () => null,
    },
    close: {
      type: Function,
      required: true,
    },
    message: {
      type: String,
      default: null,
    },
    model: {
      type: Number,
      default: null,
    },
    serie: {
      type: Number,
      default: null,
    },
  },
  methods: {
    async save() {
      try {
        const { model, serie, enableToSendIntermediator } = this;

        const payload = {
          serie,
          ativo: true,
          documento: model,
          intermediatorNFCe: enableToSendIntermediator,
        };

        await this.$http.post('fiscal.put-configuracao', payload);
        await this.onSave();
        this.close();

        return true;
      } catch (e) {
        return this.$alert.error(e?.response?.data?.error_message);
      }
    },

    handleMessage(message) {
      const enabledItermediator = 'NF-e sem indicativo do intermediador';
      const disabledItermediator = 'NF-e não pode ter o indicativo do intermediador';

      if (message.indexOf(enabledItermediator) !== -1) {
        this.enableToSendIntermediator = true;
      }

      if (message.indexOf(disabledItermediator) !== -1) {
        this.enableToSendIntermediator = false;
      }
    },
  },
  mounted() {
    if (!this.message) return;
    this.handleMessage(this.message);
  },
};
</script>
